import * as React from "react";
import { Box } from "@mui/material";

export default function ShimmerOverlay({
                                           show,
                                           borderRadius = 0,
                                           darkness = 0.55, // 👈 new prop (0 → 1)
                                           sx = {},
                                       }) {
    if (!show) return null;

    return (
        <Box
            sx={{
                position: "absolute",
                inset: 0,
                borderRadius,
                overflow: "hidden",
                pointerEvents: "none",
                zIndex: 10,
                ...sx,
            }}
        >
            {/* 👇 DARK BASE LAYER */}
            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    backgroundColor: `rgba(0,0,0,${darkness})`,
                }}
            />

            {/* 👇 SHIMMER LIGHT SWEEP */}
            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    overflow: "hidden",
                    "&::after": {
                        content: '""',
                        position: "absolute",
                        top: 0,
                        left: "-40%",
                        width: "40%",
                        height: "100%",
                        background:
                            "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.25) 50%, rgba(255,255,255,0) 100%)",
                        animation: "shimmer-slide 1.2s ease-in-out infinite",
                    },
                    "@keyframes shimmer-slide": {
                        "0%": { transform: "translateX(0)" },
                        "100%": { transform: "translateX(250%)" },
                    },
                }}
            />
        </Box>
    );
}